import { render, staticRenderFns } from "./prepare-edit.vue?vue&type=template&id=248105fe"
import script from "./prepare-edit.vue?vue&type=script&lang=js"
export * from "./prepare-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports